// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jk-0";
export var assigneeDetails = "_jk-1";
export var assigneeInfo = "_jk-2";
export var dropdownContainer = "_jk-4";
export var dropdownImage = "_jk-5";
export var editAssigneeInfo = "_jk-3";
export var editAssigneeModalContainer = "_jk-6";
export var hidden = "_jk-8";
export var input = "_jk-7";